import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Controller, Control, RegisterOptions } from 'react-hook-form';
import { DeepMap } from 'react-hook-form/dist/types/utils';
import { Branch } from 'api/branchApi';
import { colors } from '@mui/material';

interface Props {
  branchId: string;
  control: Control;
  name: string;
  rules?: RegisterOptions;
  errors: DeepMap<any, any>;
  label: string;
  className?: string;
  branches: Branch[];
}


const BranchAutocomplete = React.memo(
  ({ branchId, control, name, rules, errors, label , branches }: Props) => {
    const [open, setOpen] = useState(false);
    return (
      <div>
        <Controller
          name={name}
          rules={rules}
          control={control}
          render={(props) => (
            <Autocomplete
              {...props}
              key={branchId}
              autoHighlight
              autoSelect
              open={open}
              onOpen={() => setOpen(true)}
              onClose={() => setOpen(false)}
              options={branches || []}
              loadingText="Loading branches..."
              getOptionLabel={(option) => option.name}
              getOptionSelected={(option, value) => option?.id === value?.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={label}
                  size="medium"
                  value=""
                  variant="outlined"
                  style={{ fontSize: '1.3rem' }}
                  error={!!errors[name]}
                  helperText={!!errors[name] && errors[name].message}
                  InputProps={{
                    ...params.InputProps,
                  }}
                  InputLabelProps={{
                    style: { fontSize: '1rem',color: colors.grey[600] },
                  }}
                />
              )}
              onChange={(_, data) => {
                return props.onChange(data);
              }}
            />
          )}
        />
      </div>
    );
  }
);

export default BranchAutocomplete;
